import { CondOperator, RequestQueryBuilder } from '@nestjsx/crud-request'
import { productActions } from './../../../product/product.actions'
import { configurationOptionSelectors } from 'src/app/features/configuration-option/configuration-option.selectors'
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms'
import { DateGroupFormValue, TargetGroup } from 'src/app/shared/models'
import {
  distinctUntilChanged,
  filter,
  map,
  mergeMap,
  startWith,
  take,
  withLatestFrom
} from 'rxjs/operators'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import moment from 'moment-mini'
import { combineLatest, Observable } from 'rxjs'
import { markFormGroupDirty } from '../../../../shared/utils/mark-form-dirty'
import { NzDatePickerComponent } from 'ng-zorro-antd/date-picker'
import { LoadingModalService } from 'src/app/shared/services/loading-modal.service'

import { Store } from '@ngrx/store'
import { ConfigurationOption } from 'src/app/features/configuration-option/configuration-option'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { persistentUserRoleSelectors } from 'src/app/features/role/user-role/persistent-user-role/persistent-user-role.selector'
import { Actions, ofType } from '@ngrx/effects'
import { FormFieldConfig } from '../../../../shared/interfaces'
import { environment } from 'src/environments/environment'

@UntilDestroy()
@Component({
  selector: 'booking-multi-day-dates-groups',
  templateUrl: './dates-groups.component.html',
  styleUrls: ['./dates-groups.component.scss']
})
export class DatesGroupsComponent implements OnInit {
  @Input() isLoading: boolean = true
  @Output() onSubmit = new EventEmitter<DateGroupFormValue>()

  @Input() bookingDetails: DateGroupFormValue

  public form: UntypedFormGroup

  public targetGroupsOptions: {
    id?: string
    label: string
    value: string
    icon?: string
  }[] = [
    {
      id: 'category2',
      label: 'bookingModule.adults',
      value: 'adults',
      icon: 'fa fa-user-friends'
    },
    {
      id: 'category1',
      label: 'bookingModule.kids',
      value: 'kids',
      icon: 'fa fa-child'
    },
    {
      id: 'category3',
      label: 'bookingModule.profs',
      value: 'profs',
      icon: 'fa fa-user-tie'
    },
    {
      label: 'bookingModule.commercials',
      value: 'commercials',
      icon: 'fa fa-suitcase'
    }
  ]

  public targetGroupsLimit = {
    adults: 18,
    kids: 18,
    profs: 18,
    commercials: 2
  }
  today = new Date()

  public disabledMonthsAhead: Date

  public categories: any
  public member$: Observable<any>
  public categories$: Observable<ConfigurationOption[]>
  public categoriesByLang$: Observable<any>
  public sleepingOverMax: number
  @ViewChild('endDatePicker') endDatePicker!: NzDatePickerComponent

  constructor(
    private fb: UntypedFormBuilder,
    private configurationService: ConfigurationService,
    private loadingModalService: LoadingModalService,
    private store: Store,
    private actions$: Actions
  ) {}

  ngOnInit(): void {
    this.disabledMonthsAhead = moment(this.today)
      .add(2, 'months')
      .endOf('day')
      .toDate()
    this.member$ = this.store.select(
      persistentUserRoleSelectors.selectSelectedUserRole
    )
    this.form = this.fb.group({
      targetGroup: ['adults', Validators.required],
      isSleepOver: [false],
      is75SleepOver: [false],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      productIdSleepingOver: [null, []],
      participants: this.fb.group({
        numberSleepOver: [null, Validators.min(0)]
      })
    })

    this.categories$ = this.member$.pipe(
      withLatestFrom(this.store.select(configurationOptionSelectors.selectAll)),
      map(([member, configurationOptions]) => {
        const siteId = member.siteId ?? environment.defaultSiteId
        let mappedconfigurationOption = JSON.parse(
          JSON.stringify(configurationOptions)
        )
        mappedconfigurationOption.map((item) => {
          if (item.siteId == null) {
            item.siteId = environment.defaultSiteId
          }
        })
        configurationOptions = JSON.parse(
          JSON.stringify(mappedconfigurationOption)
        )
        configurationOptions.map((item) => {
          if (!item.siteId) {
            item.siteId = environment.defaultSiteId
          }
        })

        return configurationOptions.filter((item) => item.siteId == siteId)
      })
    )
    this.categoriesByLang$ = combineLatest([
      this.member$,
      this.configurationService.selectedLang$
    ]).pipe(
      untilDestroyed(this),
      distinctUntilChanged((a, b) => JSON.stringify(a) == JSON.stringify(b)),
      map(([member, lang]) => {
        this.categories$.pipe(take(1)).subscribe((categories) => {
          this.targetGroupsOptions.map((targetItem) => {
            if (
              categories.find(
                (categorie) => categorie.key == `${lang}_${targetItem.id}desc`
              )
            ) {
              const label = categories.find(
                (categorie) => categorie.key == `${lang}_${targetItem.id}desc`
              ).value
              targetItem.label = label ? label : targetItem.label
            }
          })
        })
      })
    )
    this.categoriesByLang$.pipe(untilDestroyed(this)).subscribe()

    combineLatest([
      this.form.get('targetGroup').valueChanges.pipe(startWith('adults')),
      this.form.get('isSleepOver').valueChanges.pipe(startWith(false)),
      this.form.get('is75SleepOver').valueChanges.pipe(startWith(false))
    ])
      .pipe(untilDestroyed(this))
      .subscribe(([targetGroup, isSleepOver, is75SleepOver]) => {
        this.updateDisabledMoths(targetGroup, isSleepOver, is75SleepOver)
        this.updateFormValidation(isSleepOver)
      })

    this.store
      .select(
        configurationOptionSelectors.selectByKey,
        'product_groups_purchase_flow_cf'
      )
      .pipe(take(1))
      .subscribe((configOption) => {
        if (
          !configOption ||
          !configOption.value ||
          !JSON.parse(configOption.value).rooms.productIds
        ) {
          this.loadingModalService.handle(false)
          return
        }
        const totalProductsToSearch = JSON.parse(configOption.value).rooms
          .productIds.length
        this.store.dispatch(
          productActions.fetchMany({
            params: RequestQueryBuilder.create({
              search: {
                id: {
                  [CondOperator.IN]: JSON.parse(configOption.value).rooms
                    .productIds
                }
              }
            })
          })
        )
        this.actions$
          .pipe(ofType(productActions.upsertMany))
          .subscribe((action) => {
            if (action && action.entities.length <= totalProductsToSearch) {
              let maxParticipants = action.entities[0].maxParticipants || 0
              let productIdWithMaxParticipants = action.entities[0].id
              for (const product of action.entities) {
                if (product.maxParticipants > maxParticipants) {
                  maxParticipants = product.maxParticipants
                  productIdWithMaxParticipants = product.id
                }
              }
              this.form.controls.productIdSleepingOver.patchValue(
                productIdWithMaxParticipants
              )
              this.sleepingOverMax = maxParticipants
            }
          })
      })

    this.form.controls.participants.valueChanges
      .pipe(untilDestroyed(this))
      .subscribe((change) => {
        if (change.numberSleepOver > this.sleepingOverMax) {
          this.form.controls.participants[
            'controls'
          ].numberSleepOver.markAsDirty()
          this.form.controls.participants['controls'].numberSleepOver.setErrors(
            { invalid: true }
          )
        } else {
          this.form.controls.participants['controls'].numberSleepOver.setErrors(
            null
          )
        }
      })
  }

  ngOnChanges() {
    // this.loadingModalService.handle(this.isLoading)
  }

  onSubmitFormValues() {
    if (this.form.invalid) {
      markFormGroupDirty(this.form)
      return
    }
    this.onSubmit.emit(this.form.value)
  }

  disabledStartDate = (currentDate: Date): boolean => {
    if (currentDate.getTime() > this.disabledMonthsAhead.getTime()) {
      return true
    }

    if (moment(currentDate).diff(moment(this.today), 'days') < 0) {
      return true
    }
    if (!currentDate || !this.form.get('endDate').value) {
      return false
    }

    return currentDate.getTime() > this.form.get('endDate').value.getTime()
  }

  disabledEndDate = (currentDate: Date): boolean => {
    if (!currentDate || !this.form.get('startDate').value) {
      return false
    }
    return (
      moment(currentDate).diff(
        moment(this.form.get('startDate').value),
        'days'
      ) < 0
    )
  }

  handleStartOpenChange(open: boolean): void {
    if (!open) {
      this.endDatePicker.open()
      this.endDatePicker.nzDefaultPickerValue = this.form.get('startDate').value
    }
  }

  handleEndOpenChange(open: boolean): void {}

  private updateFormValidation(isSleepOver) {
    const numberSleepOver = this.form.get('participants').get('numberSleepOver')

    if (isSleepOver === true) {
      numberSleepOver.setValidators([Validators.required, Validators.min(0)])
    } else {
      numberSleepOver.clearValidators()
    }
    numberSleepOver.updateValueAndValidity()
  }

  private updateDisabledMoths(
    group: TargetGroup,
    isSleepOver: boolean,
    is75SleepOver: boolean
  ) {
    let months = 3
    const isSleepOver75 = isSleepOver && is75SleepOver
    switch (group) {
      case 'adults':
        months = isSleepOver75 ? 27 : 18
        break
      case 'commercials':
        months = isSleepOver75 ? 3 : 2
        break
      case 'kids':
        months = isSleepOver75 ? 39 : 18
        break
      case 'profs':
        months = isSleepOver75 ? 27 : 18
        break
    }

    this.disabledMonthsAhead = moment(this.today)
      .add(months, 'months')
      .endOf('day')
      .toDate()
    console.log(
      `disabledMonthsAhead for ${months} months from ${this.today.toISOString()} until ${this.disabledMonthsAhead.toISOString()}`
    )
    this.form.get('startDate').setValue(null, true)
    this.form.get('endDate').setValue(null, true)
  }

  private getEndOfDay(dt: Date): Date {
    return moment(dt).endOf('day').toDate()
  }

  ngOnDestroy() {
    this.loadingModalService.handle(false)
  }
}
